import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	starred: {
		defaultMessage: 'Starred',
		id: 'atlassian-navigation.projects.menu.favorite-content.starred',
		description: 'Starred project item',
	},
});
